export type RuleSetRecord = {
  id: string;
  tenantId: string;
  name: string;
  status: string;
  version: number;
  description?: string;
  ruleSetType: string;
  category: string;
  tags?: string[];
  dataSource: DataSource;
  filterExpression: FilterExpression;
  rules?: Rule[];
  environment?: number;
};

export type DataSource = {
  entityTypeId: string;
  entitySource?: string;
  dependentEntities?: DependentEntity[];
  selectExpressions?: string[];
};

export type DependentEntity = {
  entityTypeId: string;
  entitySource: string;
  onColumnExpression: string;
  joinType: string;
  tableAlias: string;
  selectExpressions: string[];
};

export type Rule = {
  ruleId: string;
  ruleName?: string;
  errorMessage?: string;
  expression?: Expression;
  optional?: boolean;
  dataQuality?: string[];
  successEvent?: string;
};

export type FilterExpression = {
  compiledExpression: CompiledExpression;
};

export type Expression = {
  jsonQuery?: string;
  compiledExpression: CompiledExpression;
};

export type CompiledExpression = {
  cSharp?: string;
  python?: string;
  sql?: string;
};

export const RuleSetTypeSingle = 'Single';
export const RuleSetTypeComplex = 'Complex';
